import { useNavigationPresentation } from '@/lib/tradeNavigation';
import { useTradeFieldPresentation } from '@/lib/tradeFieldPresentation';
import TradesOnboarding from '@/components/trades/TradesOnboarding';
import OnboardingStart from './OnboardingStart';
import OnboardingSession from './OnboardingSession';
import { Navigate } from 'react-router-dom';
function Surface({session=false}) {
  const p=useNavigationPresentation(),f=useTradeFieldPresentation();
  if(p.pending||f.pending)return <p role="status" className="p-6">Loading setup…</p>;
  if(f.trades)return <Navigate to="/app" replace/>;
  if(p.trades)return <TradesOnboarding/>;
  return session?<OnboardingSession/>:<OnboardingStart/>;
}
export function OperatingOnboardingStart(){return <Surface/>;}
export function OperatingOnboardingSession(){return <Surface session/>;}
